import React from 'react';
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Chip from '@material-ui/core/Chip';
import LinearProgress from '@material-ui/core/LinearProgress';
//Part

import PartChargeIcon from './PartChargeIcon';
//Icon
import CloseIcon from '@material-ui/icons/Close';

class Comp extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      recordingTime: 0,
      onRecording: false,
      onPlay: false,
      recordedPlayingDuration: null,
      recordedPlayingTime: 0,
    }
    //this.audioRef = React.createRef();
  }

  _init() {
    this.audioCtx = null;
    this.audioData = [];
    this.sampleRate = null;
    this.recordingStartStamp = null;
    this.recordingTimeLimit = 20;
    this.localStream  = null;
    this.source = null;
    this.scriptNode = null;
    this.bufferSize = 44100;
  }

	_startRecording() {
    this._init();
		let audioContext = window.AudioContext || window.webkitAudioContext;
		this.audioCtx = new audioContext();
		this.sampleRate = this.audioCtx.sampleRate;


    navigator.mediaDevices.getUserMedia({audio: true}).then( (stream) => {
      this.recordingStartStamp = Date.now();
      this.setState({onRecording: true});

      this.localStream = stream;
			this.source = this.audioCtx.createMediaStreamSource(stream);
			this.scriptNode = this.audioCtx.createScriptProcessor(0, 1, 1);
			this.bufferSize = this.scriptNode.bufferSize;

      this.source.connect(this.scriptNode);
			this.scriptNode.connect(this.audioCtx.destination);

      this.scriptNode.onaudioprocess = (e) => {
        var input = e.inputBuffer.getChannelData(0);
        var bufferData = new Float32Array(this.bufferSize);
        for (var i = 0; i < this.bufferSize; i++) {
          bufferData[i] = input[i];
        }
        this.audioData.push(bufferData);
        let recordingTime = Math.round( (Date.now() - this.recordingStartStamp) / 100) / 10;
        if (recordingTime >= this.recordingTimeLimit) {
          this._stopRecording();
        }
        this.setState({recordingTime:recordingTime});
      }
    })
		.catch(function(err) {
      if (err.name === 'NotAllowedError') {
				alert('マイクへアクセスが拒否されました。');
			}
			else if (err.name === 'NotFoundError') {
				alert('録音可能なマイクが接続されていません');
			}
			else {
				alert('録音できませんでした。ページを再読み込みして録音してください' + err);
			}
      console.log(err);
    });
  };


  _stopRecording() {
    let audioBlob = this._exportWAV(this.audioData);
    this.props.setVoiceMailAudioWav(audioBlob);

    this.localStream.getTracks().forEach(function(track) {
      track.stop();
    });
    this.scriptNode.disconnect(this.audioCtx.destination);
    this.source.disconnect(this.scriptNode);

    this.setState({onRecording: false});
  }

  _exportWAV(audioData) {
		var mergeBuffers = function(audioData) {
			var sampleLength = 0;
			for (var c = 0; c < audioData.length; c++) {
				sampleLength += audioData[c].length;
			}

			var samples = new Float32Array(sampleLength);
			var sampleIdx = 0;

			for (var i = 0; i < audioData.length; i++) {
				for (var j = 0; j < audioData[i].length; j++) {
					samples[sampleIdx] = audioData[i][j];
	        sampleIdx++;
				}
			}
			return samples;
		};

    var encodeWAV = function(samples, sampleRate) {
			var buffer = new ArrayBuffer(44 + samples.length * 2);
			var view = new DataView(buffer);

			var writeString = function(view, offset, string) {
				for (var i = 0; i < string.length; i++){
					view.setUint8(offset + i, string.charCodeAt(i));
				}
			};

			var floatTo16BitPCM = function(output, offset, input) {
				for (var i = 0; i < input.length; i++, offset += 2){
					var s = Math.max(-1, Math.min(1, input[i]));
					output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
				}
			};

			writeString(view, 0, 'RIFF');  // RIFFヘッダ
			view.setUint32(4, 32 + samples.length * 2, true); // これ以降のファイルサイズ
			writeString(view, 8, 'WAVE'); // WAVEヘッダ
			writeString(view, 12, 'fmt '); // fmtチャンク
			view.setUint32(16, 16, true); // fmtチャンクのバイト数
			view.setUint16(20, 1, true); // フォーマットID
			view.setUint16(22, 1, true); // チャンネル数
			view.setUint32(24, sampleRate, true); // サンプリングレート
			view.setUint32(28, sampleRate * 2, true); // データ速度
			view.setUint16(32, 2, true); // ブロックサイズ
			view.setUint16(34, 16, true); // サンプルあたりのビット数
			writeString(view, 36, 'data'); // dataチャンク
			view.setUint32(40, samples.length * 2, true); // 波形データのバイト数
			floatTo16BitPCM(view, 44, samples); // 波形データ
			return view;
		};

		var dataview = encodeWAV(mergeBuffers(audioData), this.sampleRate);
		var audioBlob = new Blob([dataview], { type: 'audio/wav' });

		return audioBlob;
	};

  _audioPlay() {
    let URL = window.URL || window.webkitURL;
    let url = URL.createObjectURL(this.props.voiceMailAudioWav);
    this.audio = new Audio(url);
    this.audio.play();

    this.setState({onPlay: true});
    let duration;
    let time;

    this.audio.addEventListener('timeupdate', function(e) {
      duration = Math.round(e.target.duration * 10) / 10;
      this.setState({recordedPlayingDuration: duration});
      time = Math.round(e.target.currentTime * 10) / 10;
      this.setState({recordedPlayingTime: time});
    }.bind(this));

    this.audio.addEventListener('ended', function(e) {
      this._audioStop();
    }.bind(this));
  }

  _audioStop() {
    this.setState({onPlay:false, recordedPlayingTime:null, recordedPlayingDuration:null});

    this.audio.pause();
    this.audio.currentTime = 0;
    this.audio = null;
  }


  render() {
    let contents;
    if (this.props.checkBool === true) {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        contents = (
          <div>
            ブラウザが録音に対応していません
          </div>
        )
      }
      else if (this.props.checkType === 'approach') {
        contents = (
          <div>
            <div align='center' style={{padding:'5px'}}>
              無料メールでは送れません
            </div>
            <div align='center'>
              <PartChargeIcon/>
            </div>
          </div>
        )
      }
      else {
        contents = (
          <div>
            {
              (this.state.onRecording) ? (
                <div>
                  <div align='center' style={{padding:'10px'}}>
                    <Chip
                      label="録音中"
                      color="secondary"
                      variant="outlined"
                    />
                  </div>

                  <div align='center' style={{padding:'10px'}}>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={ () => this._stopRecording() }
                      style={{minWidth:'200px'}}
                    >
                      停止する
                    </Button>
                  </div>

                  <div align='center' style={{padding:'10px'}}>
                    {this.state.recordingTime} / {this.recordingTimeLimit}秒
                    <LinearProgress
                      variant="determinate"
                      value={ Math.round(this.state.recordingTime / this.recordingTimeLimit * 100) }
                      color="secondary"
                    />
                  </div>
                </div>
              ) : (
                <div align='center' style={{padding:'10px'}}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={ () => this._startRecording() }
                    style={{minWidth:'200px'}}
                  >
                    録音する
                  </Button>
                </div>
              )
            }
            {
              (this.props.voiceMailAudioWav && !this.state.onRecording) && (
                <div>
                  {
                    (this.state.onPlay) ? (
                      <div align='center' style={{padding:'10px'}}>
                        <Button
                          color="primary"
                          variant="outlined"
                          onClick={ () => this._audioStop() }
                          style={{minWidth:'200px'}}
                        >
                          停止
                        </Button>
                      </div>
                    ): (
                      <div align='center' style={{padding:'10px'}}>
                        <Button
                          color="primary"
                          variant="outlined"
                          onClick={ () => this._audioPlay() }
                          style={{minWidth:'200px'}}
                        >
                          再生する
                        </Button>
                      </div>
                    )
                  }
                  {
                    (this.state.recordedPlayingDuration) && (
                      <div align='center' style={{padding:'10px'}}>
                        <div>
                          <LinearProgress
                            variant="determinate"
                            value={ Math.round(this.state.recordedPlayingTime / this.state.recordedPlayingDuration * 100) }
                            color="primary"
                          />
                        </div>
                        <div>{ this.state.recordedPlayingDuration } s</div>
                      </div>
                    )
                  }
                  <div align='center' style={{padding:'10px'}}>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{minWidth:'200px'}}
                      onClick={ () => {
                        this.props.submit('voice');
                        this._init();
                      }}
                    >
                      <span style={{fontSize:'1.4em'}}>送信する</span>
                    </Button>
                  </div>

                  <div style={{padding:'10px', fontSize:'0.9em',}}>
                    <ul style={{marginLeft:'20px'}}>
                      <li>録音するを押してください</li>
                      <li>マイク許可ダイアログが表示したら「許可」を押してください</li>
                      <li>録音中と表示したら20秒以内で録音してください<br />(録音は何回でも録り直しできます)</li>
                    </ul>
                  </div>
                </div>
              )
            }
          </div>
        )
      }
    }
    else {
      if (this.props.checkType === 'noCharge') {
        contents = (
          <div>
            <div align='center' style={{padding:'5px'}}>
              無料メールでは送れません
            </div>
            <div align='center'>
              <PartChargeIcon/>
            </div>
          </div>
        )
      }
      else if (this.props.checkType === 'noProof') {
        contents = (
          <div>
            {
              (this.props.my.profile.userdata_sex === 'men') ? (
                <div align='center' style={{padding:'5px'}}>
                  無料メールを送信するには<br />
                  本人証明が必要です
                </div>
              ) : (
                <div align='center' style={{padding:'5px'}}>
                  メールを送信するには<br />
                  本人証明が必要です
                </div>
              )
            }

            <div align='center' style={{padding:'5px'}}>
              <Link to="/my/proof/person">
                <Button
                  variant="contained"
                  color='primary'
                  style={{minWidth:'200px'}}
                >
                  <span>本人証明を申請する</span>
                </Button>
              </Link>
            </div>
          </div>
        )
      }
      else {
        contents = (
          <div>
            {this.props.checkComment}
          </div>
        )
      }
    }

    return (
      <Dialog
        open={this.props.open}
        maxWidth='xs'
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            ボイスメールを送信
          </div>
          {
            (this.state.onRecording === false) && (
              <IconButton
                onClick={ () => {
                  this._init();
                  this.props.close();
                }}
              >
                <CloseIcon/>
              </IconButton>
            )
          }
        </div>
        <div style={{padding:'0px 10px', fontSize:'0.9em',color:'#666'}}>
          音声メールをお相手だけに送信できます。<br/>
          送信後にメール削除すると、受信側の音声データも削除される安心システム。
        </div>
        <div style={{padding:'10px'}}>
          { contents }
        </div>

      </Dialog>
    )
  }
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
